import React from "react";
import Drawer from "@material-ui/core/Drawer";
import AllDoctorsContent from "./AllDoctorContent";

const SelectDoctorMobileView = (props) => {
  const { show, onHide } = props;
  return (
    <Drawer
      className="doctor-drawer"
      anchor="right"
      open={show}
      onClose={onHide}
      // variant="persistent"
      role="presentation"
    >
      <div className="p-3">
        <AllDoctorsContent onHide={onHide} />
      </div>
    </Drawer>
  );
};

export default SelectDoctorMobileView;
